const notes = [
  { key: "G#9/Ab9", value: 128 },
  { key: "G9", value: 127 },
  { key: "F#9/Gb9", value: 126 },
  { key: "F9", value: 125 },
  { key: "E9", value: 124 },
  { key: "D#9/Eb9", value: 123 },
  { key: "D9", value: 122 },
  { key: "C#9/Db9", value: 121 },
  { key: "C9", value: 120 },
  { key: "B8", value: 119 },
  { key: "A#8/Bb8", value: 118 },
  { key: "A8", value: 117 },
  { key: "G#8/Ab8", value: 116 },
  { key: "G8", value: 115 },
  { key: "F#8/Gb8", value: 114 },
  { key: "F8", value: 113 },
  { key: "E8", value: 112 },
  { key: "D#8/Eb8", value: 111 },
  { key: "D8", value: 110 },
  { key: "C#8/Db8", value: 109 },
  { key: "C8", value: 108 },
  { key: "B7", value: 107 },
  { key: "A#7/Bb7", value: 106 },
  { key: "A7", value: 105 },
  { key: "G#7/Ab7", value: 104 },
  { key: "G7", value: 103 },
  { key: "F#7/Gb7", value: 102 },
  { key: "F7", value: 101 },
  { key: "E7", value: 100 },
  { key: "D#7/Eb7", value: 99 },
  { key: "D7", value: 98 },
  { key: "C#7/Db7", value: 97 },
  { key: "C7", value: 96 },
  { key: "B6", value: 95 },
  { key: "A#6/Bb6", value: 94 },
  { key: "A6", value: 93 },
  { key: "G#6/Ab6", value: 92 },
  { key: "G6", value: 91 },
  { key: "F#6/Gb6", value: 90 },
  { key: "F6", value: 89 },
  { key: "E6", value: 88 },
  { key: "D#6/Eb6", value: 87 },
  { key: "D6", value: 86 },
  { key: "C#6/Db6", value: 85 },
  { key: "C6", value: 84 },
  { key: "B5", value: 83 },
  { key: "A#5/Bb5", value: 82 },
  { key: "A5", value: 81 },
  { key: "G#5/Ab5", value: 80 },
  { key: "G5", value: 79 },
  { key: "F#5/Gb5", value: 78 },
  { key: "F5", value: 77 },
  { key: "E5", value: 76 },
  { key: "D#5/Eb5", value: 75 },
  { key: "D5", value: 74 },
  { key: "C#5/Db5", value: 73 },
  { key: "C5", value: 72 },
  { key: "B4", value: 71 },
  { key: "A#4/Bb4", value: 70 },
  { key: "A4 concert pitch", value: 69 },
  { key: "G#4/Ab4", value: 68 },
  { key: "G4", value: 67 },
  { key: "F#4/Gb4", value: 66 },
  { key: "F4", value: 65 },
  { key: "E4", value: 64 },
  { key: "D#4/Eb4", value: 63 },
  { key: "D4", value: 62 },
  { key: "C#4/Db4", value: 61 },
  { key: "C4", value: 60 },
  { key: "B3", value: 59 },
  { key: "A#3/Bb3", value: 58 },
  { key: "A3", value: 57 },
  { key: "G#3/Ab3", value: 56 },
  { key: "G3", value: 55 },
  { key: "F#3/Gb3", value: 54 },
  { key: "F3", value: 53 },
  { key: "E3", value: 52 },
  { key: "D#3/Eb3", value: 51 },
  { key: "D3", value: 50 },
  { key: "C#3/Db3", value: 49 },
  { key: "C3", value: 48 },
  { key: "B2", value: 47 },
  { key: "A#2/Bb2", value: 46 },
  { key: "A2", value: 45 },
  { key: "G#2/Ab2", value: 44 },
  { key: "G2", value: 43 },
  { key: "F#2/Gb2", value: 42 },
  { key: "F2", value: 41 },
  { key: "E2", value: 40 },
  { key: "D#2/Eb2", value: 39 },
  { key: "D2", value: 38 },
  { key: "C#2/Db2", value: 37 },
  { key: "C2", value: 36 },
  { key: "B1", value: 35 },
  { key: "A#1/Bb1", value: 34 },
  { key: "A1", value: 33 },
  { key: "G#1/Ab1", value: 32 },
  { key: "G1", value: 31 },
  { key: "F#1/Gb1", value: 30 },
  { key: "F1", value: 29 },
  { key: "E1", value: 28 },
  { key: "D#1/Eb1", value: 27 },
  { key: "D1", value: 26 },
  { key: "C#1/Db1", value: 25 },
  { key: "C1", value: 24 },
  { key: "B0", value: 23 },
  { key: "A#0/Bb0", value: 22 },
  { key: "A0", value: 21 },
];

export default notes;
